module.exports = __webpack_public_path__ + "img/cell-icon.4589706d.png";